import { useTranslation } from 'react-i18next';
import { NotificationMenu } from './NotificationMenu.js';

/**
 * @aiPurpose Topbar "messages" notification surface (#2107) — chat
 *   notifications only, rendered as a `message-square` icon to the left of
 *   the events bell. Shares the single `['notifications','list']` query.
 */
export function NotificationMessages() {
  const { t } = useTranslation('shell');
  return (
    <NotificationMenu
      channel="messages"
      icon="message-square"
      ariaLabel={t('messages.button')}
      testIdPrefix="topbar-messages"
    />
  );
}
